import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=519ab516&scoped=true&"
import script from "./dashboard?vue&type=script&lang=ts&"
export * from "./dashboard?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519ab516",
  null
  
)

export default component.exports